<script setup lang="ts">
const { loadLayout, layoutData } = useLayout()
await loadLayout()

const isOpen = ref(false)

const openMenu = () => {
  isOpen.value = true
}

const closeMenu = () => {
  isOpen.value = false
}

const toggleMenu = () => {
  if (isOpen.value) {
    closeMenu()
  }
  else {
    openMenu()
  }
}
</script>

<template>
  <ul class="extra-links">
    <li class="extra-links__item">
      <AppLink
        to="/wishlist/"
        class="extra-links__link"
      >
        {{ $t('My wishlist') }}
      </AppLink>
    </li>
    <li
      v-for="item in layoutData?.serviceLinks?.[0]?.Links || []"
      :key="item.id"
      class="extra-links__item"
    >
      <NuxtLink
        :to="item.Link"
        class="extra-links__link"
      >{{ item.Name }}</NuxtLink>
    </li>
    <li
      v-if="layoutData?.aboutUs?.[0]?.Links?.length"
      ref="sublinks"
      class="extra-links__item"
    >
      <button
        id="extra-links__button"
        type="button"
        class="extra-links__link"
        :aria-expanded="isOpen ? 'true' : 'false'"
        aria-haspopup="true"
        aria-controls="extra-links__panel"
        @click="toggleMenu"
      >
        <span>{{ layoutData?.aboutUs?.[0]?.Title }}</span>
        <Icon name="icon:arrow" />
      </button>

      <div
        id="extra-links__panel"
        class="extra-links__panel"
        :class="{ 'extra-links__panel--open': isOpen }"
        role="menu"
        aria-labelledby="extra-links__button"
      >
        <button
          type="button"
          class="extra-links__back"
          aria-haspopup="true"
          :aria-expanded="isOpen ? 'true' : 'false'"
          @click="toggleMenu"
        >
          <span>{{ layoutData?.aboutUs?.[0]?.Title }}</span>
          <Icon
            name="icon:arrow"
            class="icon--arrow-left"
          />
        </button>

        <ul class="extra-links">
          <li
            v-for="item in layoutData?.aboutUs[0].Links"
            :key="item.id"
            class="extra-links__item"
          >
            <NuxtLink
              :to="item.Link"
              role="menuitem"
              class="extra-links__link"
            >{{ item.Name }}</NuxtLink>
          </li>
        </ul>
      </div>
    </li>
  </ul>
</template>

<style>
@import url("~layers/app/components/Navigation/ExtraLinks.css");
</style>
